export default __webpack_public_path__ + "static/media/crypto.79dddc03.svg";